<template>
  <b-row class="mb-32">
    <b-col cols="12" class="mb-32">
      <b-row align-v="center" align-h="between">
        <!-- <b-col cols="12" md="6">
          <h3>Welcome back, Edward 👋</h3>
          <p class="hp-p1-body mb-0">
            Your current status and analytics are here
          </p>
        </b-col> -->

        <!-- <b-col class="hp-flex-none w-auto">
          <b-form-select v-model="selected" :options="options"></b-form-select>
        </b-col> -->
      </b-row>
    </b-col>

    <b-col cols="12">
      <b-row>
        <b-col cols="12" md="6" xl="3" class="mb-32 d-flex">
          <router-link :to="{ name: 'ListVehicle' }" class="text-decoration-none dashboard-card-link">
            <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                  <b-avatar class="bg-success hp-bg-color-dark-success" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-car-front-fill" style="color: white;">
                        <path d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679c.033.161.049.325.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.807.807 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H6ZM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17 1.247 0 3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                  <h3 class="mb-4 mt-8">
                    {{ totalVehicles }}
                  </h3>

                  <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                    Total Approved Vehicles
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </router-link>
        </b-col>
        <!-- ..............2nd  box......  -->
         <b-col cols="12" md="6" xl="3" class="mb-32 d-flex">
          <router-link :to="{ name: 'ListVehicle' }" class="text-decoration-none dashboard-card-link">
            <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                  <b-avatar class="bg-warning hp-bg-color-dark-warning" style="background: linear-gradient(135deg, #d88430, #2f3e46); color: #fff;" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-hourglass-split" style="color: white;">
                        <path d="M2.5 15a.5.5 0 1 1 0-1h1.586l-1.293-1.293a.5.5 0 0 1 0-.708L5.5 9.293V6.707L2.793 4a.5.5 0 0 1 0-.708L4.086 2H2.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1.586L13.207 3.293a.5.5 0 0 1 0 .708L10.5 6.707v2.586l2.707 2.707a.5.5 0 0 1 0 .708L11.914 14h1.586a.5.5 0 0 1 0 1h-11zm2-1h7.586L10.5 12.414V9.586L8.914 8H7.086L5.5 9.586v2.828L4.086 14zM5.5 6.414L7.086 8h1.828L10.5 6.414V3.586L8.914 2H7.086L5.5 3.586v2.828z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                  <h3 class="mb-4 mt-8">
                    {{ total_pending_vehicles }}
                  </h3>

                  <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                    Total Pending Vehicle
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </router-link>
        </b-col>
        <!-- ...............................  3rd  box-->
        <b-col cols="12" md="6" xl="3" class="mb-32 d-flex">
          <router-link :to="{ path: '/recover/vehicle/theft/list' }" class="text-decoration-none dashboard-card-link">
            <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                  <b-avatar class="bg-info hp-bg-color-dark-info" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-arrow-clockwise" style="color: white;">
                        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                  <h3 class="mb-4 mt-8">
                    {{ totalRecoverVehicles }}
                  </h3>

                  <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                    Total Recover Vehicles
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </router-link>
        </b-col>
        <!-- ..............................4th box   -->

        <b-col cols="12" md="6" xl="3" class="mb-32 d-flex">
          <router-link :to="{ path: '/list/theft' }" class="text-decoration-none dashboard-card-link">
            <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                   <b-avatar class="bg-danger hp-bg-color-dark-danger" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-exclamation-triangle-fill" style="color: white;">
                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                  <h3 class="mb-4 mt-8">
                    {{ totalTheftVehicles }}
                  </h3>

                  <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                    Total Theft Vehicles
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </router-link>
        </b-col>
        <!-- ................. 5th  box  -->
         <b-col cols="12" md="6" xl="3" class="mb-32 d-flex">
          <router-link :to="{ path: '/view/list/user/' }" class="text-decoration-none dashboard-card-link">
            <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                   <b-avatar class="bg-primary hp-bg-color-dark-primary" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-people-fill" style="color: white;">
                        <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                  <h3 class="mb-4 mt-8">
                    {{ totalUserApproved }}
                  </h3>

                  <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                    Total User Approved
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </router-link>
        </b-col>
         <!-- .........................6th  box  -->
        <b-col cols="12" md="6" xl="3" class="mb-32 d-flex">
          <router-link :to="{ path: '/request/list' }" class="text-decoration-none dashboard-card-link">
            <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                  <b-avatar class="bg-warning hp-bg-color-dark-warning" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-file-earmark-text-fill" style="color: white;">
                        <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM4.5 9a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1h-4z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                  <h3 class="mb-4 mt-8">
                    {{ totalPendingRequest }}
                  </h3>

                  <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                    Total Pending Request
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </router-link>
        </b-col>
        <!-- .........................7th  box  -->
        <b-col cols="12" md="6" xl="3" class="mb-32 d-flex">
          <router-link :to="{ path: '/list/police' }" class="text-decoration-none dashboard-card-link">
            <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                  <b-avatar class="bg-secondary hp-bg-color-dark-secondary" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-shield-fill-check" style="color: white;">
                        <path fill-rule="evenodd" d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm2.146 5.146a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                  <h3 class="mb-4 mt-8">
                    {{ totalPolice }}
                  </h3>

                  <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                    Total Police
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </router-link>
        </b-col>
        <!-- ...................................8th  box  -->
        <b-col cols="12" md="6" xl="3" class="mb-32 d-flex">
          <router-link :to="{ path: '/list/marketplace' }" class="text-decoration-none dashboard-card-link">
            <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                  <b-avatar class="bg-primary hp-bg-color-dark-primary" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-shop" style="color: white;">
                        <path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976L2.97 1.35zM1.5 5.625c0 .76.616 1.375 1.375 1.375S4.25 6.385 4.25 5.625 3.634 4.25 2.875 4.25 1.5 4.865 1.5 5.625zM15 5.625c0 .76-.616 1.375-1.375 1.375S12.25 6.385 12.25 5.625s.616-1.375 1.375-1.375S15 4.865 15 5.625zM7.25 5.625c0 .76-.616 1.375-1.375 1.375S4.5 6.385 4.5 5.625 5.116 4.25 5.875 4.25s1.375.615 1.375 1.375zM9.125 4.25c-.76 0-1.375.615-1.375 1.375s.616 1.375 1.375 1.375 1.375-.615 1.375-1.375S9.885 4.25 9.125 4.25z"/>
                        <path d="M2 7.625V15a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7.625c-.533.32-1.17.5-1.875.5a3.12 3.12 0 0 1-2.625-1.417 3.12 3.12 0 0 1-2.625 1.417c-.705 0-1.342-.18-1.875-.5z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                  <h3 class="mb-4 mt-8">
                    {{ totalMarketPlace }}
                  </h3>

                  <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                    Total Market Place
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </router-link>
        </b-col>
        <!-- .............................9th  box  -->
        <b-col cols="12" md="6" xl="3" class="mb-32 d-flex">
          <router-link :to="{ path: '/list/schedule' }" class="text-decoration-none dashboard-card-link">
            <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                  <b-avatar class="bg-secondary hp-bg-color-dark-secondary" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-calendar-check-fill" style="color: white;">
                        <path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-5.146-5.146-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                  <h3 class="mb-4 mt-8">
                    {{ totalSchedulePending }}
                  </h3>

                  <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                    Total Schedule Pending
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </router-link>
        </b-col>
        <!-- ............................10th  box  -->
        <b-col cols="12" md="6" xl="3" class="mb-32 d-flex">
          <router-link :to="{ path: '/list/branch' }" class="text-decoration-none dashboard-card-link">
            <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                  <b-avatar class="bg-info hp-bg-color-dark-info" style="background: linear-gradient(135deg, #385e62, #4caf50); color: #fff;" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-geo-alt-fill" style="color: white;">
                        <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                  <h3 class="mb-4 mt-8">
                    {{ totalBranch }}
                  </h3>

                  <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                    Total Inspection Location
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </router-link>
        </b-col>
        <!-- ................11th  box  -->
        <b-col cols="12" md="6" xl="3" class="mb-32 d-flex">
          <router-link :to="{ path: '/list/insurance/company' }" class="text-decoration-none dashboard-card-link">
            <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                  <b-avatar class="bg-info hp-bg-color-dark-info"   style="background: linear-gradient(135deg, #12a2b2, #3a5f8a); color: #fff;" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-building-fill" style="color: white;">
                        <path d="M3 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3v-3.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V16h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H3Zm1 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5ZM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM4.5 8h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                  <h3 class="mb-4 mt-8">
                    {{ totalInsuranceCompany }}
                  </h3>

                  <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                    Total Business Partners
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </router-link>
        </b-col>
        <!-- ................12th  box  -->
        <b-col cols="12" md="6" xl="3" class="mb-32 d-flex">
          <router-link :to="{ path: '/list/product' }" class="text-decoration-none dashboard-card-link">
            <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                  <b-avatar class="bg-success hp-bg-color-dark-success" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-box-fill" style="color: white;">
                        <path fill-rule="evenodd" d="M15.528 2.973a.75.75 0 0 1 .472.696v8.662a.75.75 0 0 1-.472.696l-7.25 2.9a.75.75 0 0 1-.557 0l-7.25-2.9A.75.75 0 0 1 0 12.331V3.669a.75.75 0 0 1 .471-.696L7.443.184l.004-.001.274-.110a.75.75 0 0 1 .558 0l.274.110.004.001 6.971 2.789Zm-1.374.527L8 5.962 1.846 3.5 1 3.839v.4l6.5 2.6v7.922l.5.2.5-.2V6.84l6.5-2.6v-.4l-.846-.339Z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                  <h3 class="mb-4 mt-8">
                    {{ totalProduct }}
                  </h3>

                  <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                    Total Product
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </router-link>
        </b-col>
        <!-- ................13th  box  -->
        <b-col cols="12" md="6" xl="3" class="mb-32 d-flex">
          <router-link :to="{ path: '/list/order' }" class="text-decoration-none dashboard-card-link">
            <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                    <b-avatar
                      size="48px"
                      class="hp-bg-color-dark-info"
                      style="background: linear-gradient(135deg, #279a10, #4caf50); color: #fff;"
                    >
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-cart-fill" style="color: white;">
                        <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                  <h3 class="mb-4 mt-8">
                    {{ totalOrder }}
                  </h3>

                  <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                    Total Order Pending
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </router-link>
        </b-col>
        <!-- .... -->
        <!-- ................14th  box  -->
        <b-col cols="12" md="6" xl="3" class="mb-32 d-flex">
          <router-link :to="{ path: '/view/list/user/' }" class="text-decoration-none dashboard-card-link">
          <b-card class="dashboard-card">
            <b-row>
              <b-col class="hp-flex-none w-auto">
                <b-avatar class="bg-success hp-bg-color-dark-success" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-check-circle-fill" style="color: white;">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.061L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                      </svg>
                    </i>
                  </b-avatar>
              </b-col>

              <b-col class="pl-0">
                <h3 class="mb-4 mt-8">
                  {{ totalcompanyapproved }}
                </h3>

                <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                  Total Company Approved
                </p>
              </b-col>
            </b-row>
          </b-card>
        </router-link>
        </b-col>

        <!-- ................15th  box  -->
        <b-col cols="12" md="6" xl="3" class="mb-32 d-flex">
          <router-link :to="{ path: '/request/list' }" class="text-decoration-none dashboard-card-link">
          <b-card class="dashboard-card">
            <b-row>
              <b-col class="hp-flex-none w-auto">
                <b-avatar class="bg-warning hp-bg-color-dark-warning" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-clipboard-check-fill" style="color: white;">
                        <path d="M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3Zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3Z"/>
                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5v-1Zm6.854 7.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708Z"/>
                      </svg>
                    </i>
                  </b-avatar>
              </b-col>

              <b-col class="pl-0">
                <h3 class="mb-4 mt-8">
                  {{ totalpendingcompanyrequests }}
                </h3>

                <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                  Total Pending Company Request
                </p>
              </b-col>
            </b-row>
          </b-card>
        </router-link>
        </b-col>
        <!-- ................16th  box  -->
        <b-col cols="12" md="6" xl="3" class="mb-32 d-flex">
          <router-link :to="{ name: 'ListStakeholder' }" class="text-decoration-none dashboard-card-link">
            <b-card class="dashboard-card">
              <b-row>
                <b-col class="hp-flex-none w-auto">
                  <b-avatar class="bg-dark hp-bg-color-dark-dark" size="48px">
                    <i>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor"
                        viewBox="0 0 16 16" class="bi bi-diagram-3-fill" style="color: white;">
                        <path fill-rule="evenodd" d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v-.5A.5.5 0 0 1 3 7h5.5V6A1.5 1.5 0 0 1 7 4.5v-1zM1.5 10A1.5 1.5 0 0 1 3 8.5h1A1.5 1.5 0 0 1 5.5 10v1A1.5 1.5 0 0 1 4 12.5H3A1.5 1.5 0 0 1 1.5 11v-1zm9 0A1.5 1.5 0 0 1 12 8.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1z"/>
                      </svg>
                    </i>
                  </b-avatar>
                </b-col>

                <b-col class="pl-0">
                  <h3 class="mb-4 mt-8">
                    {{ total_stakeholders }}
                  </h3>
                  <p class="hp-p1-body mb-0 text-black-80 hp-text-color-dark-30">
                    Total Stakeholders
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </router-link>
        </b-col>

        <b-col cols="12" xl="12">
          <b-row>
            <b-col cols="12" class="mb-32">
              <revenue-column-card />
            </b-col>

            <!-- <b-col cols="12" class="mb-32">
              <latest-orders />
            </b-col> -->

            <!-- <b-col cols="12" class="mb-32">
              <b-row>
                <b-col cols="12" md="6" class="mb-32">
                  <revenue-card />
                </b-col>

                <b-col cols="12" md="6" class="mb-32">
                  <browser-states />
                </b-col>
              </b-row>
            </b-col> -->
          </b-row>
        </b-col>

        <!-- <b-col cols="12" xl="4">
          <b-row>
            <b-col cols="12" class="mb-32">
              <earnings-card />
            </b-col>

            <b-col cols="12" class="mb-32">
              <cta-card-two />
            </b-col>

            <b-col cols="12" class="mb-32">
              <check-detail-card />
            </b-col>
          </b-row>
        </b-col> -->

        <!-- <b-col cols="12">
          <best-selling-products />
        </b-col> -->
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard, BAvatar } from "bootstrap-vue";
import axios from "axios";
import RevenueColumnCard from "../../widgets/cards/analytics/RevenueColumnCard.vue";
import LatestOrders from "./LatestOrders.vue";
import RevenueCard from "../../widgets/cards/statistics/RevenueCard.vue";
import BrowserStates from "./BrowserStates.vue";
import EarningsCard from "./EarningsCard.vue";
import CheckDetailCard from "./CheckDetailCard.vue";
import BestSellingProducts from "./BestSellingProducts.vue";
import CtaCardTwo from "../../widgets/cards/advance/CtaCardTwo.vue";

export default {
  data() {
    return {
      totalVehicles: 0,
      totalTheftVehicles: 0,
      totalRecoverVehicles: 0,
      totalUserApproved: 0,
      totalPendingRequest: 0,
      totalPolice: 0,
      totalMarketPlace: 0,
      totalSchedulePending: 0,
      totalBranch: 0,
      totalInsuranceCompany: 0,
      totalOrder: 0,
      totalProduct: 0,
      totalcompanyapproved: 0,
      totalpendingcompanyrequests: 0,
      total_pending_vehicles: 0,
      total_stakeholders: 0,
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BAvatar,
    RevenueColumnCard,
    LatestOrders,
    RevenueCard,
    BrowserStates,
    EarningsCard,
    CheckDetailCard,
    BestSellingProducts,
    CtaCardTwo,
  },
  mounted() {
    this.getDashboardData();
  },
  methods: {
    async getDashboardData() {
      try {
        const response = await axios.get("/dashboard");
        if (response.data.success) {
          this.totalVehicles = response.data.data.total_vehicles;
          this.totalTheftVehicles = response.data.data.total_theft_vehicles;
          this.totalRecoverVehicles = response.data.data.total_recover_vehicles;
          this.totalUserApproved = response.data.data.total_user_approved;
          this.totalPendingRequest = response.data.data.total_pending_requests;
          this.totalPolice = response.data.data.total_police;
          this.totalMarketPlace = response.data.data.total_market_place;
          this.totalSchedulePending = response.data.data.total_schedule_pending;
          this.totalBranch = response.data.data.total_branch;
          this.totalInsuranceCompany = response.data.data.total_insurance_company;
          this.totalProduct = response.data.data.total_product;
          this.totalOrder = response.data.data.total_order_pending;
          this.totalcompanyapproved = response.data.data.total_company_approved;
          this.totalpendingcompanyrequests = response.data.data.total_pending_company_requests;
          this.total_pending_vehicles = response.data.data.total_pending_vehicles;
          this.total_stakeholders = response.data.data.total_stakeholders;

        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    },
  },
};
</script>
<style scoped>
.dashboard-card-link {
  display: flex;
  width: 100%;
  height: 100%;
}

.dashboard-card {
  width: 100%;
  height: 100%;
  min-height: 120px;
  transition: all 0.3s ease-in-out;
  border-radius: 16px;
}

.dashboard-card >>> .card-body {
  width: 100%;
  min-height: 120px;
  display: flex;
  align-items: center;
}

.dashboard-card:hover {
  transform: translateY(-6px) scale(1.03);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.dashboard-card h3,
.dashboard-card p {
  transition: color 0.3s ease-in-out;
}

.dashboard-card p {
  min-height: 24px;
  line-height: 1.3;
}

.dashboard-card:hover h3 {
  color: #2f855a; /* Slight highlight on hover */
}
</style>